import axios from "../helper/axios";
import { create } from "zustand";

const useNuJobDetailsStore = create((set) => ({
  selectedJD: null,
  myResumes: [],
  myJds: [],
  myApplications: [],
  skilledBasedJobs: [], 
  ViewedJobs:[], 
  ViewedResponseMetadata:[], 
  totalSkillsBasedJds:null,
  totalViewed:null,
  totalApplied:null,
  totalFavorite:null,
  totalViewedCount:null,
  profileCompleted:0,
  isFresher : false,
  AppliedJobs:[],
  totalAppliedCount:0,
  AppliedResponseMetadata:[],
  FavJobs:[],
  totalFavCount:0,
  FavResponseMetadata:[],
  SkillResponseMetadata:[],
  linkjob:[],
  linkstatus:null,
  subscriptionPlans:[],
  mySubscription:[],
  refreshProfile:false,
  jdStatusAfterLogin:"",
  applicationStatusAfterLogin:"",
  profileStatusAfterLogin:"",
  resumeStatusAfterLogin:"",  
  incompleteJDs:[],
  employerTotalJDs:0,
  employerTotalActiveJDs:0,
  employerTotalApplications:0,
  employerTotalRecentApplications:0,
  employerRecentJDs:[],
  employerApplicationsPerJD:[],
  employerGraphData:[],
  employerTotalEvents:0,
  employerTotalUpcomingEvents:0,

  nujobsGetMyResumes: async (cb) => {
        try {
            console.log("nujobsGetMyResumes");
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nujobsGetMyResumes/${userData.nujoid}/${userData.nujuid}`
            );          
            set({ myResumes: response.data.resumeDBs });
            set({ isFresher: response.data.isfresher });
            console.log(response.data.name);
            console.log(response.data);
            if(cb) cb(response.data.isfresher)
        } catch (error) {
            console.log(error);
        }
    },
    nuJobsGetMyJDs: async () => {
        try {
            console.log("nuJobsGetMyJDs",);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsGetMyJDs/${userData.nujoid}/${userData.nujuid}`
            );            
            set({ myJds: response.data.myJds });
            console.log(response.data.name);
            console.log(response.data.myJds);
        } catch (error) {
            console.log(error);
        }
    },
    nuJobsGetMyApplications: async () => {
        try {
            console.log("nuJobsGetMyApplications");
            const response = await axios.post(
                `nuJobsGetMyApplications`
            );
            set({ myJds: response.data.myApplications });
            console.log(response.data.name);
            console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    },    
    nujobsApplyNow: async (resume_index, body, cb) => {
        try {
            console.log("nuJobsApplyNow",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsApplyNow/${userData.nujoid}/${userData.nujuid}/${resume_index}`, body
            );            
            console.log(response.data.name);
            if(cb) cb();
        } catch (error) {
            console.log(error);
        }
    },  
    nujobsReportIncompleteApplication: async (body) => {
        try {
            console.log("nujobsReportIncompleteApplication",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsSetIncompleteApplication/${userData.nujoid}/${userData.nujuid}`, body
            );    
            console.log(response.data.name);
        } catch (error) {
            console.log(error);
        }
    }, 
    nuJobsDisardIncompleteJd: async (body,cb) => {
        try {
            console.log("nuJobsDisardIncompleteJd",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsDisardIncompleteJd/${userData.nujoid}/${userData.nujuid}`, body
            );    
            
            if(cb) cb();

            console.log(response.data.name);
        } catch (error) {
            console.log(error);
        }
    },     
    
    nuJobsGetIncompleteJds: async () => {
        try {
            console.log("nuJobsGetIncompleteJds");
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `nuJobsGetIncompleteJds/${userData.nujoid}/${userData.nujuid}`
            );
            set({ incompleteJDs: response.data.incompleteapps });        
            console.log(response.data.name);
            console.log(response.data.incompleteapps);
        } catch (error) {
            console.log(error);
        }
    },       
    nuJobsUpdateCandidateProfile: async (body) => {
        try {
            console.log("nuJobsUpdateCandidateProfile",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsUpdateCandidateProfile/${userData.nujoid}/${userData.nujuid}`, body
            );    
            set({ refreshProfile: true });        
            console.log(response.data.name);
        } catch (error) {
            console.log(error);
        }
    },

  nujobsResetRefreshProfile: async () => {
    try {
      set({ refreshProfile: false });
    } catch (error) {
      console.log(error);
    }
  },
  nujobsSetSelectedJD: async (jobId) => {
    try {
      set({ selectedJD: jobId });
    } catch (error) {
      console.log(error);
    }
  },
  nujobsSkillsBasedsJds: async (body,resultHandler) => {
        try {
            console.log("nuJobsSkillBasedJobs Req",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsSkillBasedJobs/${userData.nujoid}/${userData.nujuid}`,body
            );

            set({ skilledBasedJobs: response.data.data });
            set({ totalSkillsBasedJds: response.data.totalJds });
            set({ SkillResponseMetadata: response.data.metadata });
            console.log("nuJobsSkillBasedJobs--",response.data);

             if(resultHandler) resultHandler(response.data.metadata)
        } catch (error) {
            console.log(error);
        }
  },  
  nujobsUserMetaDataStats: async () => {
        try {
            console.log("nuJobsgetUserMetadata Req");
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.get(
                `/nuJobsgetUserMetadata/${userData.nujoid}/${userData.nujuid}`
            );
            set({ totalViewed: response.data.totalViewed });
            set({ totalApplied: response.data.totalApplied });
            set({ totalFavorite: response.data.totalFavorite });
            set({ profileCompleted:response.data.profilecompleted})
            console.log("nuJobsgetUserMetadata",response.data);
        } catch (error) {
            console.log(error);
        }
  }, 
  nujobGetMyAppliedJobs: async (body,resultHandler) => {
        try {
            console.log("nujobGetMyAlliedJobs Req",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsGetAppliedJobs/${userData.nujoid}/${userData.nujuid}`,body
            );

            set({ AppliedJobs: response.data.data });
            set({ totalAppliedCount: response.data.totalJds });
            set({ AppliedResponseMetadata: response.data.metadata });
            
            console.log("nuJobsGetAppliedJobs",response.data);

             if(resultHandler) resultHandler(response.data.metadata)
        } catch (error) {
            console.log(error);
        }
  },   
  nujobGetMyViewdJobs: async (body,resultHandler) => {
        try {
            console.log("nuJobsGetViewedJobs Req",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsGetViewedJobs/${userData.nujoid}/${userData.nujuid}`,body
            );

            set({ ViewedJobs: response.data.data });
            set({ totalViewedCount: response.data.totalJds });
            set({ ViewedResponseMetadata: response.data.metadata });
            
            console.log("nuJobsGetViewedJobs",response.data);

             if(resultHandler) resultHandler(response.data.metadata)
        } catch (error) {
            console.log(error);
        }
  },     
  nujobGetMyFavJobs: async (body,resultHandler) => {
        try {
            console.log("nuJobsGetFavoriteJobs Req",body);
            const userData = JSON.parse(localStorage.getItem("nujobsUserDetails"));
            const response = await axios.post(
                `/nuJobsGetFavsJobs/${userData.nujoid}/${userData.nujuid}`,body
            );

            set({ FavJobs: response.data.data });
            set({ totalFavCount: response.data.totalJds });
            set({ FavResponseMetadata: response.data.metadata });
            
            console.log("nuJobsGetFavoriteJobs",response.data);

             if(resultHandler) resultHandler(response.data.metadata)
        } catch (error) {
            console.log(error);
        }
  }, 
  nuJobsRetrieveJdFromLink: async (body,qhoid,qhcompanyjid, syncCB) => {
        try {
            //console.log("nuJobsRetrieveJdFromLink",);
            const response = await axios.post(
                `/nuJobsRetrieveJdFromLink/${qhoid}/${qhcompanyjid}`,body
            );
            set({ linkJob: response.data.data });
            set({ linkstatus: response.data.status})

            if(syncCB) syncCB(response.data.data)
            //console.log(response.data.name);
            //console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    },  

  nuJobsCheckJDForApplyNowAfterLogin: async (body,qhoid,qhcompanyjid, syncCB) => {
        try {
            //console.log("nuJobsCheckJDForApplyNowAfterLogin",body);
            const response = await axios.post(
                `/nuJobsCheckJDForApplyNowAfterLogin/${qhoid}/${qhcompanyjid}`,body
            );
            //console.log(response.data.name);
            //console.log(response.data.data);            
            set({ applicationStatusAfterLogin: response.data.applicationstatus})
            set({ jdStatusAfterLogin: response.data.jdstatus})
            set({ profileStatusAfterLogin: response.data.profilestatus})
            set({ resumeStatusAfterLogin: response.data.resumestatus})

            if(syncCB) syncCB(response.data.data)

        } catch (error) {
            console.log(error);
        }
    },    
  nuJobsGetSubscriptionPlans: async (qhoid,qhuid) => {
        try {
            console.log("nuJobsGetSubscriptionPlans",);
            const response = await axios.get(
                `/nuJobsGetSubscriptionPlans/${qhoid}/${qhuid}`
            );

            set({ subscriptionPlans: response.data.data });
            
            console.log(response.data.name);
            console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }, 
  nuJobsGetMySubscriptions: async (qhoid,qhuid) => {
        try {
            console.log("nuJobsGetMySubscriptions");
            const duration = "All"
            const response = await axios.get(
                `/nuJobsGetMySubscription/${qhoid}/${qhuid}/${duration}`
            );

            set({ mySubscription: response.data.data });
            
            console.log("afewffewfefew",response.data);
            console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }, 
  nuJobsUpdateSubscriptions: async (qhoid,qhuid,body) => {
        try {
            console.log("nuJobsUpdateSubscriptions",);
            const duration = "All"
            const response = await axios.post(
                `/nuJobsUpdateSubscription/${qhoid}/${qhuid}`, body
            );
            console.log(response.data.name);
        } catch (error) {
            console.log(error);
        }
    },  
  nuJobsRenewSubscriptions: async (qhoid,qhuid,body) => {
        try {
            console.log("nuJobsRenewSubscription",);
            const duration = "All"
            const response = await axios.post(
                `/nuJobsRenewSubscription/${qhoid}/${qhuid}`,body
            );
            console.log(response.data.name);
        } catch (error) {
            console.log(error);
        }
    },

  nuJobsUpdateResumeDetails: async (qhoid,qhuid,body, cb) => {
        try {
            console.log("nuJobsUpdateResumeDetails",body);
            const response = await axios.post(
                `/nujobsUpdateResumeDetails/${qhoid}/${qhuid}`,body
            );
            console.log(response.data.name);
            if(cb) cb();
        } catch (error) {
            console.log(error);
        }
    },
    
  nuJobsCancelSubscriptions: async (qhoid,qhcompanyjid) => {
        try {
            console.log("nuJobsCancelSubscriptions",);
            const duration = "All"
            const response = await axios.post(
                `/nuJobsCancelSubscription/${qhoid}/${qhcompanyjid}`,
            );
            console.log(response.data.name);
        } catch (error) {
            console.log(error);
        }
    },    
	

  nuJobsEmployerDashboardGetStats: async (qhoid,qhuid) => {
        try {
            //console.log("nuJobsEmployerDashboardGetStats", qhoid, qhuid);
            const response = await axios.get(
                `/nuJobsEmployerDashboardGetStats/${qhoid}/${qhuid}`
            );

            set({ employerTotalJDs: response.data.totalJDs });
            set({ employerTotalActiveJDs: response.data.totalActiveJDs });
            set({ employerTotalApplications: response.data.totalApplications });
            set({ employerTotalRecentApplications: response.data.totalRecentApplications });
            set({ employerRecentJDs: response.data.recentJDs });
            set({ employerApplicationsPerJD: response.data.applicationsPerJD });
            set({ employerTotalEvents: response.data.totalEvents });
            set({ employerTotalUpcomingEvents: response.data.totalUpcomingEvents });
            //console.log(response.data);
        } catch (error) {
            console.log(error);
        }
    },     
  nuJobsGetEmployerGraphData : async (qhoid,qhuid,duration) => {
        try {
            //console.log("nuJobsGetEmployerGraphData");
            const response = await axios.get(
                `/nuJobsGetEmployerDashBoardGraphData/${qhoid}/${qhuid}/${duration}`
            );

            set({ employerGraphData: response.data.data });
            //console.log(response.data.data);
        } catch (error) {
            console.log(error);
        }
    },    
}));

export default useNuJobDetailsStore;
